/* eslint-disable */
/*
  oJo, no hacer multininea.

  oJo, poner raiz la categoría: ej.-
     Blockly.Msg["SENSOR_(nombre del mensaje)"]

  oJo, no sacar literales aunque se dupliquen (son pocas): ej.-
     Blockly.Msg["COPY_TO_BACKPACK"] = "Copiar a la motchila"; <- OK
     Blockly.Msg["COPY"] = "Copiar";                           <- NO OK
     Blockly.Msg["BACKPACK"] = "motchila";                     <- NO OK

  oJo, hacer las modificaciones en los 4 diomas a la vez!!!,
    la idea es que coincidan línea a línea,
    no dejar una traducción hecha en un idioma y no en el resto.
*/

import Blockly from "blockly";

export function AEN() {
  Blockly = {};
  Blockly.Msg = {};

  // Blocks - COMMON
  Blockly.Msg["ADD_NEW_LINE"] = "Line feed";
  Blockly.Msg["AS"] = "as";
  Blockly.Msg["BAUDRATE"] = "Baudrate";
  Blockly.Msg["BOOLEAN_FALSE"] = "falso";
  Blockly.Msg["BOOLEAN_OFF"] = "OFF";
  Blockly.Msg["BOOLEAN_ON"] = "ON";
  Blockly.Msg["BOOLEAN_TRUE"] = "verdadero";
  Blockly.Msg["COL"] = "Column";
  Blockly.Msg["COLOUR"] = "Colour";
  Blockly.Msg["DEFAULT_VAR_NAME"] = "varNum";
  Blockly.Msg["DO"] = "do";
  Blockly.Msg["FIX"] = "Fix";
  Blockly.Msg["I2C_ADDRESS"] = "Address";
  Blockly.Msg["I2C_BEGIN"] = "Begin (I2C)";
  Blockly.Msg["ID"] = "#";
  Blockly.Msg["PIN"] = "PIN";
  Blockly.Msg["ROW"] = "Row";
  Blockly.Msg["STATUS"] = "Status";
  Blockly.Msg["TIMEOUT"] = "maximum time";
  Blockly.Msg["UNTIL_NEW_LINE"] = "Until line feed";
  Blockly.Msg["VALUE"] = "Value";
  Blockly.Msg["UPLOAD"] = "Upload";  // OjO, sin traducir

  // Blocks - LOGIC
  Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = Blockly.Msg["BOOLEAN_FALSE"];
  Blockly.Msg["LOGIC_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LOGIC_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Returns either true or false.";
  Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = Blockly.Msg["BOOLEAN_TRUE"];
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Return true if both inputs equal each other.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Return true if the first input is greater than the second input.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Return true if the first input is greater than or equal to the second input.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Return true if the first input is smaller than the second input.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Return true if the first input is smaller than or equal to the second input.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Return true if both inputs are not equal to each other.";
  Blockly.Msg["LOGIC_NEGATE_TITLE"] = "not %1";
  Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Returns true if the input is false. Returns false if the input is true.";
  Blockly.Msg["LOGIC_OPERATION_AND"] = "and";
  Blockly.Msg["LOGIC_OPERATION_OR"] = "or";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Return true if both inputs are true.";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Return true if at least one of the inputs is true.";
  Blockly.Msg["LOGIC_IF_MSG_ELSE"] = "else";
  Blockly.Msg["LOGIC_IF_MSG_ELSEIF"] = "else if";
  Blockly.Msg["LOGIC_IF_MSG_IF"] = "If";
  Blockly.Msg["LOGIC_IF_MSG_THEN"] = Blockly.Msg["DO"];
  Blockly.Msg["LOGIC_IF_TOOLTIP"] = "If the comparison is true, it executes the associated blocks.";

  // Blocks - CONTROLS
  Blockly.Msg["CONTROLS_FOR_TITLE"] = "count with %1 from %2 to %3 by %4";
  Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "Have the variable '%1' take on the values from the start number to the end number, counting by the specified interval, and do the specified blocks.";
  Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "Repeat %1 times";
  Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Do some statements several times.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "Repeat until";
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "Repeat while";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "While a value is false, then do some statements.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "While a value is true, then do some statements.";
  Blockly.Msg["CONTROLS_ARDUINO_LOOP"] = "Loop";
  Blockly.Msg["CONTROLS_ARDUINO_SETUP"] = "Setup";
  Blockly.Msg["CONTROLS_GROUP"] = "Group";

  // Blocks - MATH
  Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
  Blockly.Msg["MATH_ANGLE"] = "angle";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Return the sum of the two numbers.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Return the quotient of the two numbers.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Return the difference of the two numbers.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Return the product of the two numbers.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Return the first number raised to the power of the second number.";
  Blockly.Msg["MATH_CHANGE_TITLE"] = "Change %1 by %2";
  Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Add a number to variable '%1'.";
  Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "constrain %1 low %2 high %3";
  Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Constrain a number to be between the specified limits (inclusive).";
  Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";
  Blockly.Msg["MATH_MAP_TITLE"] = "map %1 from %2 - %3 to  %4 - %5";
  Blockly.Msg["MATH_MAP_TOOLTIP"] = "Map a number from specific range to the specified range";
  Blockly.Msg["MATH_MODULO_TITLE"] = "remainder of %1 ÷ %2";
  Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Return the remainder from dividing the two numbers.";
  Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";
  Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "A number.";
  Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
  Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "random integer from %1 to %2";
  Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Return a random integer between the two specified limits, inclusive.";
  Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absolute";
  Blockly.Msg["MATH_SINGLE_OP_LN"] = "log(e)";
  Blockly.Msg["MATH_SINGLE_OP_LOG10"] = "log(10)";
  Blockly.Msg["MATH_SINGLE_OP_NEG"] = "-";
  Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "square root";
  Blockly.Msg["MATH_SINGLE_OP_ROUND"] = "round";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDDOWN"] = "round down";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDUP"] = "round up";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Return the absolute value of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Return e to the power of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Return the natural logarithm of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Return the base 10 logarithm of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Return the negation of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Return 10 to the power of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Return the square root of a number.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUND"] = "Round a number up or down.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDUP"] = "Round a number up.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDDOWN"] = "Round a number down.";
  Blockly.Msg["MATH_SINGLE_TRIG_ACOS"] = "acos";
  Blockly.Msg["MATH_SINGLE_TRIG_ASIN"] = "asin";
  Blockly.Msg["MATH_SINGLE_TRIG_ATAN"] = "atan";
  Blockly.Msg["MATH_SINGLE_TRIG_COS"] = "cos";
  Blockly.Msg["MATH_SINGLE_TRIG_SIN"] = "sin";
  Blockly.Msg["MATH_SINGLE_TRIG_TAN"] = "tan";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ACOS"] = "Return the arccosine of a number.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ASIN"] = "Return the arcsine of a number.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ATAN"] = "Return the arctangent of a number.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_COS"] = "Return the cosine of a degree (not radian).";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_SIN"] = "Return the sine of a degree (not radian).";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_TAN"] = "Return the tangent of a degree (not radian).";
  Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
  Blockly.Msg["MATH_TO_INT"] = "integer number";
  Blockly.Msg["MATH_TO_UINT"] = "unsigned integer number";
  Blockly.Msg["MATH_TRIG_ATAN2"] = "atan2";
  Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN2"] = "Return the arctangent of y/x.";

  // Blocks - TEXT
  Blockly.Msg["TEXT_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["TEXT_ASCII"] = "ASCII value";
  Blockly.Msg["TEXT_CONTAINS"] = "contains";
  Blockly.Msg["TEXT_CONTAINS_1"] = "piece";
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Add an item to the text.";
  Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "join";
  Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this text block.";
  Blockly.Msg["TEXT_DECIMAL"] = "Decimals";
  Blockly.Msg["TEXT_ENDSWITH"] = "ends with";
  Blockly.Msg["TEXT_EQUALS"] = "equals";
  Blockly.Msg["TEXT_EQUALS_IGNORE"] = "equals (ignore case)";
  Blockly.Msg["TEXT_FORMAT"] = "format número";
  Blockly.Msg["TEXT_INDEXOF"] = "find in text";
  Blockly.Msg["TEXT_INDEXOF_1"] = "piece";
  Blockly.Msg["TEXT_INDEXOF_FIRST"] = "first";
  Blockly.Msg["TEXT_INDEXOF_LAST"] = "last";
  Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "create text with";
  Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Create a piece of text by joining together any number of items.";
  Blockly.Msg["TEXT_LENGTH_TITLE"] = "length of %1";
  Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Returns the number of letters (including spaces) in the provided text.";
  Blockly.Msg["TEXT_NOT_EQUALS"] = "different";
  Blockly.Msg["TEXT_REPLACE"] = "Replace all text";
  Blockly.Msg["TEXT_REPLACE_1"] = "segment";
  Blockly.Msg["TEXT_REPLACE_2"] = "replacement";
  Blockly.Msg["TEXT_STARTSWITH"] = "starts with";
  Blockly.Msg["TEXT_SUBSTRING"] = "segment text";
  Blockly.Msg["TEXT_SUBSTRING_1"] = "start";
  Blockly.Msg["TEXT_SUBSTRING_2"] = "end";
  Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "A letter, word, or line of text.";
  Blockly.Msg["TEXT_TONUMBER"] = "Text to number";
  Blockly.Msg["TEXT_WITH"] = "with";

  // Blocks - VARIABLES
  Blockly.Msg["VARIABLES_DEFAULT_NAME"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["VARIABLES_DEFAULT_NAME_BOOL"] = "varBool";
  Blockly.Msg["VARIABLES_DEFAULT_NAME_TEXT"] = "varText";
  Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Create 'set %1'";
  Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Returns the value of this variable.";
  Blockly.Msg["VARIABLES_SET"] = "Set";
  Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Create 'get %1'";
  Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Sets this variable to be equal to the input.";

  // Blocks - LISTS
  Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "empty list";
  Blockly.Msg["LISTS_CREATE_TITLE"] = "Create list %1 %2 %3";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_NUMBER_WITH"] = "number ";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_TEXT_WITH"] = "text ";
  Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Create a list with any number of items.";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "Create numeric list";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH_TEXT"] = "Create texts list";
  Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["LISTS_GET_INDEX_GET"] = "get";
  Blockly.Msg["LISTS_GET_INDEX_TOOLTIP"] = "Devuelve el elemento en el índice indicado.";
  Blockly.Msg["LISTS_SET_INDEX_TOOLTIP"] = "Establece un elemento en el índice indicado.";
  Blockly.Msg["LISTS_LENGTH_TITLE"] = "length of ";
  Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Returns the length of a list.";
  Blockly.Msg["LISTS_LISTNAME"] = "myList";
  Blockly.Msg["LISTS_LISTNAME_TEXT"] = "myTextList";
  Blockly.Msg["LISTS_SET_INDEX_SET"] = "set";

  // Blocks - PROCEDURES
  Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "allow statements";
  Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "with:";
  Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Run the user-defined function '%1'.";
  Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Run the user-defined function '%1' and use its output.";
  Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "with:";
  Blockly.Msg["PROCEDURES_CREATE_DO"] = "Create '%1'";
  Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Describe this function…";
  Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
  Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "do something";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "To";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Creates a function with no output.";
  Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "return";
  Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Creates a function with an output.";
  Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Warning: This function has duplicate parameters.";
  Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Highlight function definition";
  Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "If a value is true, then return a second value.";
  Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Warning: This block may be used only within a function definition.";
  Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "input name:";
  Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Add an input to the function.";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "inputs";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Add, remove, or reorder inputs to this function.";
  Blockly.Msg["PROCEDURES_VARIABLE"] = "argument:";
  Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
  Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
  Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
  Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];

  // Blocks - IO
  Blockly.Msg["IO_ANALOG_READ"] = "Read analog PIN";
  Blockly.Msg["IO_ANALOG_READ_DIF"] = "Read Analog differential";
  Blockly.Msg["IO_ANALOG_WRITE"] = "Write PWM analog PIN";
  Blockly.Msg["IO_CAPACITIVE_READ"] = "Read capacitive input";
  Blockly.Msg["IO_DIGITAL_READ"] = "Read digital PIN";
  Blockly.Msg["IO_DIGITAL_WRITE"] = "Write digital PIN";
  Blockly.Msg["IO_INTERRUPT"] = "Interrupt";
  Blockly.Msg["IO_INT_RISING"] = "Rising";
  Blockly.Msg["IO_INT_FALLING"] = "Falling";
  Blockly.Msg["IO_INT_CHANGE"] = "Change";
  Blockly.Msg["IO_INT_LOW"] = "Low";
  Blockly.Msg["IO_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IO_PINMODE"] = "Configure pin";
  Blockly.Msg["IO_PINMODE_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["IO_PULSEIN"] = "Read pulse";
  Blockly.Msg["IO_PULSEIN_TIMEOUT"] = "Timeout";
  Blockly.Msg["IO_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - TIME
  Blockly.Msg["TIME_MICROS"] = "microseconds";
  Blockly.Msg["TIME_MILLIS"] = "milliseconds";
  Blockly.Msg["TIME_SECONDS"] = "seconds";
  Blockly.Msg["TIME_RUNEVERYMS"] = "Run every";
  Blockly.Msg["TIME_SNOOZE"] = "Snooze";
  Blockly.Msg["TIME_TIMER"] = "Timer";
  Blockly.Msg["TIME_TIMER_RESET"] = "Reset timer";
  Blockly.Msg["TIME_TIME_ELAPSED_SECONDS"] = "Current elapsed time seconds";
  Blockly.Msg["TIME_TIME_ELAPSED_MILLI"] = "Current elapsed time milliseconds";
  Blockly.Msg["TIME_TIME_ELAPSED_MICRO"] = "Current elapsed time microseconds";
  Blockly.Msg["TIME_WAIT"] = "Wait";
  Blockly.Msg["TIME_WAIT_FOREVER"] = "Wait forever (end)";
  Blockly.Msg["TIME_WAIT_UNTIL"] = "Wait until";
  Blockly.Msg["TIME_WAIT_WHILE"] = "Wait while";

  // Blocks - SERIAL
  Blockly.Msg["SERIAL_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SERIAL_AVAILABLE"] = "Data received?";
  Blockly.Msg["SERIAL_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["SERIAL_FLUSH"] = "Flush";
  Blockly.Msg["SERIAL_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["SERIAL_INIT"] = "Init";
  Blockly.Msg["SERIAL_INT"] = "Event on";
  Blockly.Msg["SERIAL_PLOT_CREATE_TITLE"] = "Serial Port %1 Plotter: %2 %3";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NAME"] = "name ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NUMBER"] = "value ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_TOOLTIP"] = "Plotter any number of values";
  Blockly.Msg["SERIAL_PLOT_CREATE_EMPTY_TITLE"] = "empty plot";
  Blockly.Msg["SERIAL_PRINT"] = "Send";
  Blockly.Msg["SERIAL_PRINTLN"] = "Send line";
  Blockly.Msg["SERIAL_READ"] = "Receive";
  Blockly.Msg["SERIAL_READBYTE"] = "Receive byte";
  Blockly.Msg["SERIAL_READFLOAT"] = "Receive as number";
  Blockly.Msg["SERIAL_READINT"] = "Receive as integer number";
  Blockly.Msg["SERIAL_READSTRING"] = "Receive text";
  Blockly.Msg["SERIAL_READSTRINGLINE"] = "Receive text line";
  Blockly.Msg["SERIAL"] = "Serial Port";
  Blockly.Msg["SERIAL_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["SERIAL_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["SERIAL_WRITEBYTE"] = "Send byte";

  // Blocks - SENSOR
  Blockly.Msg["SENSOR_ACCEL_ADXL345"] = "Accelerometer (ADXL345)";
  Blockly.Msg["SENSOR_ACCEL_OFFSET"] = "Offset";
  Blockly.Msg["SENSOR_BUTTON"] = "Button";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED"] = "Button debounced";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_PRESSED"] = "is pressed";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_RELEASED"] = "is released";
  Blockly.Msg["SENSOR_BUTTON_INVERT"] = "Inverted logic";
  Blockly.Msg["SENSOR_DHT11"] = "Environmental Sensor (DHT-11)";
  Blockly.Msg["SENSOR_DHT22"] = "Environmental Sensor (DHT-22)";
  Blockly.Msg["SENSOR_HUMIDITY"] = "Humidity %";
  Blockly.Msg["SENSOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SENSOR_POT"] = "Potentiometer";
  Blockly.Msg["SENSOR_SOUND"] = "Microphone";
  Blockly.Msg["SENSOR_TEMPERATURE"] = "Temperature ºC";
  Blockly.Msg["SENSOR_TEMT6000"] = "Light sensor (TEMT6000)";
  Blockly.Msg["SENSOR_TILT"] = "Tilt sensor";
  Blockly.Msg["SENSOR_TMP36"] = "Temperature sensor (TMP36)";
  Blockly.Msg["SENSOR_ULTRASONIC"] = "Distance sensor (HCSR-04)";
  Blockly.Msg["SENSOR_ULTRASONIC_MAXDISTANCE"] = "Max distance (cm)";
  Blockly.Msg["SENSOR_ULTRASONIC_UNITS"] = "Units";

  // Blocks - ACTUATOR
  Blockly.Msg["ACTUATOR_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["ACTUATOR_COMMON_ANODE"] = "common Anode";
  Blockly.Msg["ACTUATOR_COMMON_CATHODE"] = "common Cathode";
  Blockly.Msg["ACTUATOR_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["ACTUATOR_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["ACTUATOR_BUZZER"] = "Buzzer";
  Blockly.Msg["ACTUATOR_BUZZER_DURATION"] = "Duration";
  Blockly.Msg["ACTUATOR_BUZZER_FREQ"] = "Frequency";
  Blockly.Msg["ACTUATOR_BUZZER_TONE"] = "Tone";
  Blockly.Msg["ACTUATOR_NOTE_A"] = "A";
  Blockly.Msg["ACTUATOR_NOTE_AS"] = "A#";
  Blockly.Msg["ACTUATOR_NOTE_B"] = "B";
  Blockly.Msg["ACTUATOR_NOTE_C"] = "C";
  Blockly.Msg["ACTUATOR_NOTE_CS"] = "C#";
  Blockly.Msg["ACTUATOR_NOTE_D"] = "D";
  Blockly.Msg["ACTUATOR_NOTE_DS"] = "D#";
  Blockly.Msg["ACTUATOR_NOTE_E"] = "E";
  Blockly.Msg["ACTUATOR_NOTE_F"] = "F";
  Blockly.Msg["ACTUATOR_NOTE_FS"] = "F#";
  Blockly.Msg["ACTUATOR_NOTE_G"] = "G";
  Blockly.Msg["ACTUATOR_NOTE_GS"] = "G#";
  Blockly.Msg["ACTUATOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["ACTUATOR_LED"] = "Led";
  Blockly.Msg["ACTUATOR_LED_PWM"] = "Led intensity (PWM)";
  Blockly.Msg["ACTUATOR_RGBLED"] = "RGB Led";
  Blockly.Msg["ACTUATOR_SOUND_PLAY"] = "Play";
  Blockly.Msg["ACTUATOR_STATUS"] = Blockly.Msg["STATUS"];
  Blockly.Msg["ACTUATOR_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - LCD
  Blockly.Msg["LCD"] = "LCD Display";
  Blockly.Msg["LCD_BACKLIGHT"] = "Backlight";
  Blockly.Msg["LCD_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LCD_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LCD_BLINK"] = "Blink";
  Blockly.Msg["LCD_CLEAR"] = "Clear";
  Blockly.Msg["LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["LCD_CURSOR"] = "Cursor";
  Blockly.Msg["LCD_DEFINE"] = "Define";
  Blockly.Msg["LCD_DISPLAY"] = "Display";
  Blockly.Msg["LCD_EDITOR"] = "Symbol Editor";
  Blockly.Msg["LCD_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LCD_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LCD_LEFT"] = "Left";
  Blockly.Msg["LCD_RIGHT"] = "Right";
  Blockly.Msg["LCD_PRINT"] = "Print";
  Blockly.Msg["LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["LCD_SCROLL"] = "Scroll";
  Blockly.Msg["LCD_SYMBOL"] = "symbol";
  Blockly.Msg["LCD_SYMBOL_UPCASE"] = "Symbol";

  // Blocks - MATRIX
  Blockly.Msg["LEDMATRIX"] = "LED Matrix 8x8";
  Blockly.Msg["LEDMATRIX_CLEAR"] = "Clear";
  Blockly.Msg["LEDMATRIX_DRAWBITMAP"] = "Bitmap";
  Blockly.Msg["LEDMATRIX_DRAWCIRCLE"] = "Circle";
  Blockly.Msg["LEDMATRIX_DRAWPIXEL"] = "Pixel";
  Blockly.Msg["LEDMATRIX_DRAWTEXT"] = "Text";
  Blockly.Msg["LEDMATRIX_EDITOR"] = "Bitmap Editor";
  Blockly.Msg["LEDMATRIX_FILL"] = "Fill";
  Blockly.Msg["LEDMATRIX_HEIGHT"] = "Height";
  Blockly.Msg["LEDMATRIX_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["LEDMATRIX_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LEDMATRIX_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LEDMATRIX_INIT"] = "Init";
  Blockly.Msg["LEDMATRIX_LED_ON"] = "Led ON";
  Blockly.Msg["LEDMATRIX_LED_OFF"] = "Led OFF";
  Blockly.Msg["LEDMATRIX_LINE"] = "Line";
  Blockly.Msg["LEDMATRIX_RECTANGLE"] = "Rectangle";
  Blockly.Msg["LEDMATRIX_ROTATION"] = "Rotation";
  Blockly.Msg["LEDMATRIX_ROUND"] = "Rounded";
  Blockly.Msg["LEDMATRIX_SHOW"] = "Show";
  Blockly.Msg["LEDMATRIX_WIDTH"] = "Width";

  // Blocks - NEOPIXEL
  Blockly.Msg["NEOPIXEL"] = "NeoPixel";
  Blockly.Msg["NEOPIXEL_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["NEOPIXEL_CLEAR"] = "Clear";
  Blockly.Msg["NEOPIXEL_INIT"] = "Init";
  Blockly.Msg["NEOPIXEL_LEDCOUNT"] = "Number of leds";
  Blockly.Msg["NEOPIXEL_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["NEOPIXEL_PIXEL"] = "Pixel";
  Blockly.Msg["NEOPIXEL_SETMATRIX"] = "Set matrix";
  Blockly.Msg["NEOPIXEL_SETPIXEL"] = "Set pixel";
  Blockly.Msg["NEOPIXEL_SETRAW"] = "Set data";
  Blockly.Msg["NEOPIXEL_SHOW"] = "Show";
  Blockly.Msg["NEOPIXEL_EXAMPLES"] = "Examples";
  Blockly.Msg["NEOPIXEL_SPEED"] = "Speed";
  Blockly.Msg["NEOPIXEL_UNITS"] = "ms";
  Blockly.Msg["NEOPIXEL_COLOUR"] = "Colour";
  Blockly.Msg["NEOPIXEL_RED"] = "R";
  Blockly.Msg["NEOPIXEL_GREEN"] = "G";
  Blockly.Msg["NEOPIXEL_BLUE"] = "B";
  Blockly.Msg["NEOPIXEL_RAINBOW"] = "Rainbow";
  Blockly.Msg["NEOPIXEL_THEATER"] = "Theater";
  Blockly.Msg["NEOPIXEL_WIPE"] = "Wipe";
  Blockly.Msg["NEOPIXEL_CHASE"] = "Chase";
  Blockly.Msg["NEOPIXEL_BRIGHTNESS"] = "Brightness";

  // Blocks - MOTOR
  Blockly.Msg["MOTOR_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["MOTOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["MOTOR_SERVO"] = "Servo";
  Blockly.Msg["MOTOR_SERVO_DEGREE_RANGE"] = "Degrees";
  Blockly.Msg["MOTOR_SERVO_DELAY"] = "Delay";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR"] = "Oscillator";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_AMPLITUDE"] = "Amplitude";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_OFFSET"] = "Offset";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PERIOD"] = "Period (ms)";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PHASE"] = "Phase";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_REFRESH"] = "Update";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_RESET"] = "Reset";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_START"] = "Start";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_STOP"] = "Stop";
  Blockly.Msg["MOTOR_STEPPER"] = "Stepper";
  Blockly.Msg["MOTOR_STEPPER_RPM"] = "rpm";
  Blockly.Msg["MOTOR_STEPPER_SPEED"] = "Speed";
  Blockly.Msg["MOTOR_STEPPER_START"] = "Start";
  Blockly.Msg["MOTOR_STEPPER_STEP"] = "Steps";
  Blockly.Msg["MOTOR_STEPPER_STEPS"] = "Steps/Revolution";
  Blockly.Msg["MOTOR_DC_MOTOR_DC"] = "DC Motor";
  Blockly.Msg["MOTOR_DC_MOTOR"] = "Motor";
  Blockly.Msg["MOTOR_DC_BEGIN"] = "Begin";
  Blockly.Msg["MOTOR_DC_STOP"] = "Stop";
  Blockly.Msg["MOTOR_DC_DIRECTION"] = "Direction";
  Blockly.Msg["MOTOR_DC_FORDWARD"] = "Forward";
  Blockly.Msg["MOTOR_DC_SPEED"] = "Speed";
  Blockly.Msg["MOTOR_DC_BACKWARD"] = "Backward";

  // Blocks - RTC
  Blockly.Msg["RTC"] = "Digital clock";
  Blockly.Msg["RTC_DATE_TEXT"] = "Date";
  Blockly.Msg["RTC_DAY"] = "Day";
  Blockly.Msg["RTC_DAYOFWEEK"] = "Day of week";
  Blockly.Msg["RTC_FRIDAY"] = "Friday";
  Blockly.Msg["RTC_HOUR"] = "Hour";
  Blockly.Msg["RTC_MINUTE"] = "Minute";
  Blockly.Msg["RTC_MONDAY"] = "Monday";
  Blockly.Msg["RTC_MONTH"] = "Month";
  Blockly.Msg["RTC_SATURDAY"] = "Saturday";
  Blockly.Msg["RTC_SECOND"] = "Second";
  Blockly.Msg["RTC_SUNDAY"] = "Sunday";
  Blockly.Msg["RTC_THURSDAY"] = "Thursday";
  Blockly.Msg["RTC_TIME_TEXT"] = "Time";
  Blockly.Msg["RTC_TUESDAY"] = "Tuesday";
  Blockly.Msg["RTC_WEDNESDAY"] = "Wednesday";
  Blockly.Msg["RTC_YEAR"] = "Year";

  // Blocks - SD
  Blockly.Msg["SD"] = "SD Card";
  Blockly.Msg["SD_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["SD_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SD_BEGIN"] = "Init";
  Blockly.Msg["SD_EXISTS"] = "Exists file?";
  Blockly.Msg["SD_POS"] = "Position";
  Blockly.Msg["SD_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SD_PRINT"] = "Print";
  Blockly.Msg["SD_FILE"] = "File";
  Blockly.Msg["SD_READBYTE"] = "Read byte";
  Blockly.Msg["SD_READLOOP"] = "Read each byte";
  Blockly.Msg["SD_REMOVE"] = "Remove file";
  Blockly.Msg["SD_SIZE"] = "File size";
  Blockly.Msg["SD_WRITEBYTE"] = "Write byte";
  Blockly.Msg["SD_FORMAT"] = "Format";
  Blockly.Msg["SD_FORMAT_QUICK"] = "Quick format";
  Blockly.Msg["SD_ERASE"] = "Erase";
  Blockly.Msg["SD_WRITE"] = "Write";

  // Blocks - BLUETOOTH
  Blockly.Msg["BLUETOOTH_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_AVAILABLE"] = "Data received?";
  Blockly.Msg["BLUETOOTH_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLUETOOTH_DEVNAME"] = "Name";
  Blockly.Msg["BLUETOOTH_INIT"] = "Init";
  Blockly.Msg["BLUETOOTH_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["BLUETOOTH_PIN"] = "PIN code";
  Blockly.Msg["BLUETOOTH_PRINT"] = "Send";
  Blockly.Msg["BLUETOOTH_PRINTLN"] = "Send line";
  Blockly.Msg["BLUETOOTH_READBYTE"] = "Receive byte";
  Blockly.Msg["BLUETOOTH_READFLOAT"] = "Receive as number";
  Blockly.Msg["BLUETOOTH_READSTRING"] = "Receive text";
  Blockly.Msg["BLUETOOTH_READSTRINGLINE"] = "Receive text line";
  Blockly.Msg["BLUETOOTH"] = "Bluetooth";
  Blockly.Msg["BLUETOOTH_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["BLUETOOTH_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_WRITEBYTE"] = "Send byte";

  // Blocks - BLYNK BLYNK_WIFI
  Blockly.Msg["BLYNK_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLYNK_APP_CONNECTED"] = "App connected";
  Blockly.Msg["BLYNK_APP_DISCONNECTED"] = "App disconnected";
  Blockly.Msg["BLYNK_APP_READ"] = "Value requested for";
  Blockly.Msg["BLYNK_APP_WRITE"] = "Value received for";
  Blockly.Msg["BLYNK_AUTH"] = "Auth code";
  Blockly.Msg["BLYNK_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLYNK_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["BLYNK_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["BLYNK_CONNECTED"] = "Connected to server";
  Blockly.Msg["BLYNK_INIT"] = "Init";
  Blockly.Msg["BLYNK_LCD_CLEAR"] = "Clear";
  Blockly.Msg["BLYNK_LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["BLYNK_LCD_PRINT"] = "Print";
  Blockly.Msg["BLYNK_LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["BLYNK_LED"] = "Led";
  Blockly.Msg["BLYNK_LED_INTENSITY"] = "Intensity";
  Blockly.Msg["BLYNK_LOCALPORT"] = "Port";
  Blockly.Msg["BLYNK_LOCALSERVER"] = "Server IP";
  Blockly.Msg["BLYNK_GPS"] = "Map location";
  Blockly.Msg["BLYNK_GPS_LAT"] = "Latitude";
  Blockly.Msg["BLYNK_GPS_LONG"] = "Longitude";
  Blockly.Msg["BLYNK_PARAM_READ_INT"] = "PIN value";
  Blockly.Msg["BLYNK_PARAM_READ_STRING"] = "Virtual pin value (string)";
  Blockly.Msg["BLYNK_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["BLYNK_SET_PROPERTY"] = "Set property";
  Blockly.Msg["BLYNK_TERMINAL_CLEAR"] = "Clear";
  Blockly.Msg["BLYNK_TERMINAL_PRINT"] = "Print";
  Blockly.Msg["BLYNK_TIMER"] = "Timer";
  Blockly.Msg["BLYNK_VIRTUALWRITE"] = "PIN write";
  Blockly.Msg["BLYNK_VPIN_VALUE"] = "Value";
  Blockly.Msg["BLYNK_WIFI"] = "Wifi";
  Blockly.Msg["BLYNK_WIFI_NAME"] = "WiFi SSID";
  Blockly.Msg["BLYNK_WIFI_PASS"] = "WiFi Password";

  // Blocks - IFTTT OjO, sin traducir 
  Blockly.Msg["IFTTT_WEBHOOKS_KEY"] = "Webhooks Key: ";
  Blockly.Msg["IFTTT_EMAIL_TITLE"] = "Wifi %1 Email event: %2 %3";
  Blockly.Msg["IFTTT_EMAIL_TOOTLTIP"] = "Email with values";
  Blockly.Msg["IFTTT_EMAIL_VALUE"] = "value ";
  Blockly.Msg["IFTTT_SMS_EVENT"] = "SMS event:";
  Blockly.Msg["IFTTT_TWEET_EVENT"] = "Tweet event:";
  Blockly.Msg["IFTTT_TELEGRAM_EVENT"] = "Telegram event:";

  // Blocks - THINGER OjO, sin traducir
  Blockly.Msg["THINGER_USERID"] = "User ID: ";
  Blockly.Msg["THINGER_DEVICEID"] = "Device ID: ";
  Blockly.Msg["THINGER_AUTH"] = "Authorization: ";
  Blockly.Msg["THINGER_UPLOAD_TITLE"] = "Wifi %1 Upload: %2 %3";
  Blockly.Msg["THINGER_UPLOAD"] = Blockly.Msg["UPLOAD"];
  Blockly.Msg["THINGER_UPLOAD_TOOLTIP"] = "Upload any number of values";

  // Blocks - THINGSPEAK OjO, sin traducir
  Blockly.Msg["THINGSPEAK_WRITE_APIKEY"] = "Write API Key: ";
  Blockly.Msg["THINGSPEAK_UPLOAD_TITLE"] = "Wifi %1 Upload: %2 %3";
  Blockly.Msg["THINGSPEAK_UPLOAD_FIELD"] = "field ";

  // Blocks - MQTT (no publicado)
  Blockly.Msg["MQTT_BROKER"] = "Broker";
  Blockly.Msg["MQTT_CLIENTID"] = "Client Id";
  Blockly.Msg["MQTT_INIT"] = "Init";
  Blockly.Msg["MQTT_ISCONNECTED"] = "Is connected?";
  Blockly.Msg["MQTT_MAC"] = "MAC";
  Blockly.Msg["MQTT_PASS"] = "Password";
  Blockly.Msg["MQTT_PORT"] = "Port";
  Blockly.Msg["MQTT_PUB"] = "Publish";
  Blockly.Msg["MQTT_SUB"] = "Subscribe";
  Blockly.Msg["MQTT_TOPIC"] = "Topic";
  Blockly.Msg["MQTT_USER"] = "User";
  Blockly.Msg["MQTT_VALUE"] = "Value";
  Blockly.Msg["MQTT_WIFI_NAME"] = "Network (SSID)";
  Blockly.Msg["MQTT_WIFI_PASS"] = "Password";

  // Blocks - INFRARED
  Blockly.Msg["IR"] = "IR";
  Blockly.Msg["IR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IR_RX"] = "Receiver";
  Blockly.Msg["IR_RX_NUMBER"] = "Receive number in";
  Blockly.Msg["IR_TX"] = "Emitter";
  Blockly.Msg["IR_TX_BITS"] = "#Bits";
  Blockly.Msg["IR_TX_CODE"] = "Code";
  Blockly.Msg["IR_TX_DATA"] = "Data";
  Blockly.Msg["IR_TX_NUMBER"] = "Emit number in";
  Blockly.Msg["IR_TX_PROTOCOL"] = "Protocol";

  // Workspace
  Blockly.Msg["ADD_COMMENT"] = "Add Comment";
  Blockly.Msg["UNDO"] = "Undo";
  Blockly.Msg["REDO"] = "Redo";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "A variable named '%1' already exists.";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "A variable named '%1' already exists for another type: '%2'."; // untranslated
  Blockly.Msg["CHANGE_VALUE_TITLE"] = "Change value:";
  Blockly.Msg["CLEAN_UP"] = "Clean up Blocks";
  Blockly.Msg["COLLAPSE_ALL"] = "Collapse Blocks";
  Blockly.Msg["COLLAPSE_BLOCK"] = "Collapse Block";
  Blockly.Msg["DELETE_ALL_BLOCKS"] = "Delete all %1 blocks?";
  Blockly.Msg["DELETE_BLOCK"] = "Delete Block";
  Blockly.Msg["DELETE_X_BLOCKS"] = "Delete %1 Blocks";
  Blockly.Msg["DELETE_VARIABLE"] = "Delete '%1'";
  Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Delete %1 uses of the '%2' variable?";
  Blockly.Msg["DISABLE_BLOCK"] = "Disable Block";
  Blockly.Msg["DUPLICATE_BLOCK"] = "Duplicate";
  Blockly.Msg["DUPLICATE_COMMENT"] = "Duplicate Comment";
  Blockly.Msg["ENABLE_BLOCK"] = "Enable Block";
  Blockly.Msg["EXPAND_ALL"] = "Expand Blocks";
  Blockly.Msg["EXPAND_BLOCK"] = "Expand Block";
  Blockly.Msg["EXTERNAL_INPUTS"] = "External Inputs";
  Blockly.Msg["HELP"] = "Help";
  Blockly.Msg["INLINE_INPUTS"] = "Inline inputs";
  Blockly.Msg["NEW_VARIABLE"] = "New…";
  Blockly.Msg["NEW_VARIABLE_TITLE"] = "New variable name:";
  Blockly.Msg["REMOVE_COMMENT"] = "Remove Comment";
  Blockly.Msg["RENAME_VARIABLE"] = "Rename…";
  Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Rename all '%1' variables to:";
  Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Say something…";

  // Backpack
  Blockly.Msg["COPY_ALL_TO_BACKPACK"] = "Copy All Blocks to Backpack";
  Blockly.Msg["COPY_TO_BACKPACK"] = "Copy to Backpack";
  Blockly.Msg["EMPTY_BACKPACK"] = "Empty";
  Blockly.Msg["PASTE_ALL_FROM_BACKPACK"] = "Paste All Blocks from Backpack";
  Blockly.Msg["REMOVE_FROM_BACKPACK"] = "Remove from Backpack";

  return Blockly.Msg;
};
